import { createApp } from 'vue';
import App from './App.vue';
import router from './router/routing';
import './assets/css/app.css';
import BackToTop from 'vue-backtotop';
import { VueReCaptcha } from 'vue-recaptcha-v3'

const feather = require('feather-icons');
feather.replace();


createApp(App)
	.use(router)
	.use(VueReCaptcha, {
		siteKey: '6LdD5bMdAAAAAOVTEAMxXEFTIab3JUxvNnfxSnn4',
		loaderOptions: {
			autoHideBadge: true
		}
	})
	.use(BackToTop)
	.mount('#app');



const appTheme = localStorage.getItem('theme');

// Check what is the active theme
if (
	appTheme === 'dark' &&
	document.querySelector('body').classList.contains('app-theme')
) {
	document.querySelector('body').classList.add('bg-primary-dark');
} else {
	document.querySelector('body').classList.add('bg-secondary-light');
}